import { useNavigate } from 'react-router-dom'
import { useGetCountriesQuery } from './countriesApiSlice'
import { memo } from 'react'
import useLang from '../../hooks/useLang'
import useTranslate from '../../hooks/useTranslate'

// import `ChakraProvider` component
import { Icon, IconButton, Tr, Td, Tooltip } from '@chakra-ui/react'

// import `ChakraProvider` icon
import { CheckIcon, CloseIcon, EditIcon } from '@chakra-ui/icons'

const Country = ({ countryId }) => {

    const { lang } = useLang()
    const { T } = useTranslate(lang)

    const { country } = useGetCountriesQuery("countriesList", {
        selectFromResult: ({ data }) => ({
            country: data?.entities[countryId]
        }),
    })

    const navigate = useNavigate()

    if (country) {

        const handleEdit = () => navigate(`/dash/countries/${countryId}`)
        return (
            <Tr _hover={{ color: '#333333', border: '2px', borderColor: 'teal.600' }}>
                <Td>
                    {country.countryStatus
                        ? <Icon as={CheckIcon} w={4} h={4} color='green.500' title={T.common.Actived} />
                        : <Icon as={CloseIcon} w={4} h={4} color='red.500' title={T.common.Disabled} />
                    }
                </Td>

                <Td>
                    <strong>{country.countryName[lang]}</strong>
                </Td>

                <Td>
                    {country.marketName[lang]}
                </Td>

                <Td isNumeric>
                    <Tooltip hasArrow label={T.common.Edit} bg='gray.300' closeOnClick={true} color='black' placement='left'>
                        <IconButton
                            colorScheme='gray'
                            aria-label='New'
                            icon={<EditIcon />}
                            onClick={handleEdit}
                            _hover={{ bg: 'teal.600', color: 'white', borderColor: 'teal.600' }}
                        />
                    </Tooltip>
                </Td>
            </Tr>
        )

    } else return null
}

const memoizedCountry = memo(Country)

export default memoizedCountry